// these modules are needed for framework loading, but require no initialization
define('main-execute-mods',[
    'modernizr',
    'wdn_jquery',
    'legacy',
    'skipnav'
], function() {});

